import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { axiosInstanceB2B } from '@share/utils';
import { ILoginState } from '@share/store/slices';

import SideNav from "../../components/dashboard/side-nav/component";
import PersonalInfo from "./personal-info";
import { IUser } from "@share/common-types";
import { Spin } from "antd";

function PersonalInformationComponent() {
  const [userData, setUserData] = useState<IUser>();

  const loginStore = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const currentUser = loginStore.user;

  const fetchUserData = async () => {
    const getUser = await axiosInstanceB2B.get(`/identity/users/${currentUser?.userId}`);
    setUserData(getUser.data);
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <section className="pt-3">
      <div className="container">
        <div className="row">
          <SideNav />
          <div className="col-lg-8 col-xl-9">
            <Spin spinning={!userData}>
              <PersonalInfo data={userData} />
            </Spin>
          </div>
        </div>
      </div>
    </section>
  );
}

const PersonalInformation = PersonalInformationComponent;
export default PersonalInformation;